import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfigService } from '@fmnts/api/util';
import { Observable } from 'rxjs';
import { IApiFeatureRequestDto } from '../model/feature-request';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class FeatureRequestApi {
  private static readonly rootUrl = '/api/feature-request/v1';
  readonly #http = inject(HttpClient);
  readonly #configService = inject(ApiConfigService);

  /**
   * Saves a feature request
   *
   * @param featureRequest The feature request to save
   *
   * @returns An `Observable` of the response
   */
  save(
    featureRequest: IApiFeatureRequestDto,
  ): Observable<IApiFeatureRequestDto> {
    const url = this.#configService.buildApiUrl([FeatureRequestApi.rootUrl]);
    return this.#http.post<IApiFeatureRequestDto>(
      url,
      featureRequest,
      httpOptions,
    );
  }
}
